<template>
  <div class="px-4">
    <v-row class="align-stretch pt-6">
      <!-- <v-col cols="12" md="12" >
        <div class="d-flex " >
          <v-card class="mx-2" elevation="0" color="#eeeeee">
            <div class="d-flex flex-column jusify-center"></div>
            <v-card-title >Atendimento em vendas</v-card-title>
            <v-card-subtitle><span class="primary--text font-weight-bold">amanda@themediatrade.com</span></v-card-subtitle>
          </v-card>
          <v-card class="mx-2" elevation="0" color="#eeeeee">
            <div class="d-flex flex-column jusify-center"></div>
            <v-card-title >Suporte TI</v-card-title>
            <v-card-subtitle><span class="primary--text font-weight-bold">yan@themediatrade.com</span></v-card-subtitle>
          </v-card>
          <v-card class="mx-2" elevation="0" color="#eeeeee"> 
            <div class="d-flex flex-column jusify-center"></div>
            <v-card-title >Apoio em marketing</v-card-title>
            <v-card-subtitle><span class="primary--text font-weight-bold">cezar@themediatrade.com</span></v-card-subtitle>
          </v-card>
        </div>
      </v-col> -->
      <v-col v-if="currentPlan && currentPlan.name" style cols="12" md="6">
        <v-card
          elevation="0"
          outlined
          v-if="selectedPlan"
          height="100%"
          class="subscription-card pa-4"
        >
          <div class="d-flex justify-space-between">
            <div
              v-if="currentPlan.name"
              class="text-h5 font-weight-bold primary--text"
            >
              <div class="d-flex justify-space-between align-center">
                <span class="text-h5 font-weight-bold primary--text">
                  {{ currentPlan.name }}</span
                >
                <v-chip
                  outlined
                  x-small
                  label
                  color="#e7ebf5"
                  class="green--text ml-2 px-1"
                  dark
                  small
                  >{{ $t("common.active") }}</v-chip
                >
              </div>
            </div>
            <div class="mr-4">
              <v-btn color="text" text @click="showPlans = true"
                >{{ $t("account.whitelabel.resource.btnSwitchPlan")
                }}<v-icon class="ml-4" small>mdi-arrow-right</v-icon></v-btn
              >
            </div>
          </div>
          <div class="d-flex align-baseline justify-space-between">
            <div class="d-flex flex-column font-weight-bold">
              <div class="d-flex flex-column"></div>
              <span class="mb-4">
                <span class="d-block title font-weight-semi-bold">{{
                  $n(yearPrice, "currency")
                }}</span
                >{{ $t("account.whitelabel.resource.resourceDialog.perYear") }}
              </span>
            </div>
            <!-- botoes de sign -->
            <!-- <div class="d-flex flex-column">
                <v-btn v-if="!selectedPlan._id == currentPlan._id.$id" :disabled="selectedPlan._id == currentPlan._id.$id"
                  :loading="loading" @click="signaturePlan()" target="_blank" color="green" class="white--text">{{
                    selectedPlan._id == currentPlan._id.$id
                    ? "Plano Ativo"
                    : "Ativar Plano"
                  }}</v-btn>
              </div> -->
          </div>
          <div class="mb-4 text-subtitle pa-0">
            <v-card-subtitle class="mb-4" style="padding: 0px">
              <div class="d-flex flex-column">
                <span
                  class=""
                  v-for="(adv, i) in currentPlan.advantagesText"
                  :key="i"
                >
                  <v-icon class="mr-2">mdi-check</v-icon>{{ adv }}
                </span>
              </div>
            </v-card-subtitle>
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="d-flex align-baseline justify-space-between mb-2">
            <div class="d-flex flex-column font-weight-bold">
              <div class="d-flex flex-column"></div>
              <div class="subtitle text-subtitle">
                <span class="d-block title font-weight-semi-bold">{{
                  ` ${selectedPlan?.commission} % `
                }}</span
                >{{
                  $t(
                    "account.whitelabel.resource.resourceDialog.transactCommision"
                  )
                }}
              </div>
            </div>
          </div>
          <v-card-subtitle class="mb-4" style="padding: 0px">
            <div class="d-flex flex-column">
              <span
                class=""
                v-for="(adv, i) in currentPlan.resourcesText"
                :key="i"
              >
                <v-icon class="mr-2">mdi-check</v-icon>{{ adv }}
              </span>
            </div>
          </v-card-subtitle>
          <v-card color="#eeeeee" elevation="0" class="" v-if="doc && ['Bra', 'Brasil'].includes(doc.origin)">
            <v-card-text>
              <span class="font-weight-bold">        {{
                    $t(
                      "account.whitelabel.resource.resourceDialog.bonus.title"
                    )
                  }}</span>
              <div class="d-flex align-end mb-2">
                <v-icon class="mr-2">mdi-check</v-icon>
                <span>
                  <strong class="green--text">{{
                    `${selectedPlan.resources?.discountStore} % ${this.$t(
                      "account.whitelabel.resource.resourceDialog.discount"
                    )} `
                  }}</strong>
                  {{
                    $t(
                      "account.whitelabel.resource.resourceDialog.bonus.tmtStore"
                    )
                  }}
                </span>
                <v-img
                  max-width="25"
                  class="ml-2"
                  width="25"
                  src="https://store.themediatrade.com/img/tmstorelogo.2b74392e.svg"
                ></v-img>
              </div>
              <div class="d-flex align-end mb-4">
                <v-icon class="mr-2">mdi-check</v-icon>
                <span>
              {{ $t(
                      "account.whitelabel.resource.resourceDialog.bonus.includedProducts"
                    ) }}
                </span>
                <v-img
                  class="ml-2 "
                  max-width="110"
                  src="https://tmt-s3-v2.s3.amazonaws.com/public/tunad_logo.svg"
                ></v-img>
              </div>
              <div class="d-flex align-center ">
                <v-icon class="mr-2">mdi-check</v-icon>
            <span>
              {{$t(
                      "account.whitelabel.resource.resourceDialog.bonus.includedProducts"
                    )}}
                </span>
                <v-img
                  class="ml-2"
                  max-width="150"
                  src="https://tmt-s3-v2.s3.amazonaws.com/public/kantaribopemedia_logo.svg"
                ></v-img>
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="6"
        xl="5"
        class=""
        v-if="!currentPlan || !currentPlan.name"
      >
        <v-card
          elevation="0"
          outlined
          v-if="selectedPlan || !currentPlan.name"
          class="subscription-card pa-4"
        >
          <v-card-text>
            <div class="d-flex flex-column">
              <v-alert text type="error">
                O seu plano está inativo. Assine um novo ou reative o seu para
                ter acesso a todos os recursos da plataforma.</v-alert
              >
              <!-- v-if="!currentPlan && !currentPlan.name" -->
              <div class="text-h5 font-weight-bold green--text">
                <div class="d-flex">
                  <v-spacer></v-spacer>
                  <v-btn
                    x-large
                    color="green"
                    elevation="0"
                    class="white--text"
                    @click="showPlans = true"
                    >{{ $t("account.whitelabel.resource.signNewPlan")
                    }}<v-icon class="ml-4" small>mdi-file-sign</v-icon></v-btn
                  >
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="6" xl="5">
        <div class="d-flex flex-column">
          <div class="d-flex align-center align-baseline justify-space-between">
            <v-card-title class="display-5 pa-0 mr-6">
              {{ $t("account.whitelabel.resource.monthlyMonitoring") }}
            </v-card-title>
            <v-select
              disabled
              outlined
              tile
              dense
              width="100"
              :label="$t('common.underDev')"
            ></v-select>
          </div>
          <div>
            <v-row>
              <v-col md="6" sm="12">
                <v-card
                  height="200"
                  width="100%"
                  class="py-9 d-flex align-center justify-center"
                  color="#e7ebf5"
                  elevation="0"
                >
                  <div class="d-flex flex-column align-center justify-center">
                    <div class="text-center text-h3 primary--text">
                      {{ newVisitors }}
                    </div>
                    <div class="text-center font-weight-bold">
                      {{ $t("account.whitelabel.resource.uniqueVisitors") }}
                    </div>
                    <div
                      class="text-center text-caption font-weight-bold grey--text mt-3"
                    >
                      {{ $t("account.whitelabel.resource.limitOf") }}
                      {{ currentPlan?.limits?.users }}
                      {{ this.$t("common.aMonth") }}
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col md="6" sm="12">
                <v-card
                  height="200"
                  width="100%"
                  class="py-9 d-flex align-center justify-center"
                  color="#e7ebf5"
                  elevation="0"
                >
                  <div class="d-flex flex-column align-center justify-center">
                    <div class="text-center text-h3 primary--text">
                      {{ totalTransactions }}
                    </div>
                    <div class="text-center font-weight-bold">
                      {{ $t("account.whitelabel.resource.transactions") }}
                    </div>
                    <div
                      class="text-center text-caption font-weight-bold grey--text mt-3"
                    >
                      {{ $t("account.whitelabel.resource.limitOf") }} 0
                      {{ this.$t("common.aMonth") }}
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" sm="12">
                <v-card
                  height="200"
                  width="100%"
                  class="py-9 d-flex align-center justify-center"
                  color="#e7ebf5"
                  elevation="0"
                >
                  <div
                    class="d-flex flex-column align-center justify-center contain"
                  >
                    <div class="text-center text-h3 primary--text">
                      <!-- {{ $n(getGrossTransact, "currency") }} -->
                      <i18n-n :value="getGrossTransact" format="currency">
                        <template v-slot:currency="slotProps">
                          <small
                            :class="
                              getGrossTransact < 2000000
                                ? 'display-1'
                                : 'headline'
                            "
                            >{{ slotProps.currency }}</small
                          >
                        </template>
                        <template v-slot:integer="slotProps">
                          <span
                            :class="
                              getGrossTransact < 2000000
                                ? 'display-1'
                                : 'headline'
                            "
                            >{{ slotProps.integer }}</span
                          >
                        </template>
                        <template v-slot:group="slotProps">
                          <span
                            :class="
                              getGrossTransact < 2000000
                                ? 'display-1'
                                : 'headline'
                            "
                            >{{ slotProps.group }}</span
                          >
                        </template>
                        <template v-slot:fraction="slotProps">
                          <small
                            :class="
                              getGrossTransact < 2000000
                                ? 'display-1'
                                : 'headline'
                            "
                            >{{ slotProps.fraction }}</small
                          >
                        </template>
                      </i18n-n>
                    </div>
                    <div class="text-center font-weight-bold">
                      {{ $t("account.whitelabel.resource.grossCarriedAmount") }}
                    </div>
                    <div
                      class="text-center text-caption font-weight-bold grey--text mt-3"
                    >
                      {{ $t("account.whitelabel.resource.limitOf") }}
                      {{
                        this.$n(
                          currentPlan?.limits?.grossRevenue,
                          "currency",
                          selectedPlan?.currency
                        )
                      }}{{ this.$t("common.aMonth") }}
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col md="6" sm="12">
                <v-card
                  height="200"
                  width="100%"
                  class="py-9 d-flex align-center justify-center"
                  color="#e7ebf5"
                  elevation="0"
                >
                  <div class="d-flex flex-column align-center justify-center">
                    <div class="text-center text-h3 primary--text">0</div>
                    <div class="text-center font-weight-bold">
                      {{ $t("account.whitelabel.resource.proposalsSent") }}
                    </div>
                    <div
                      class="text-center text-caption font-weight-bold grey--text mt-3"
                    >
                      {{ $t("account.whitelabel.resource.limitOf") }}
                      {{ this.$t("common.aMonth") }}
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-dialog max-width="1080" v-model="showPlans">
      <v-card class="mx-auto" :loading="loadingPlans">
        <v-card-title class="font-weight-bold"
          >{{ $t("account.whitelabel.resource.resourceDialog.plans")
          }}<v-spacer></v-spacer
          ><v-btn icon @click="showPlans = false"
            ><v-icon>mdi-close</v-icon></v-btn
          ></v-card-title
        >

        <v-row class="mx-4">
          <v-col cols="6">
            <v-card
              class="my-2"
              elevation="0"
              outlined
              v-for="plan in allPlans"
              :key="plan._id"
              :class="
                plan._id == selectedPlan?._id ? 'primary white--text' : ''
              "
              @click="selectPlan(plan)"
            >
              <div class="d-flex align-baseline">
                <v-card-title class="">{{ plan.name }}</v-card-title>
                <h5
                  v-if="
                    plan._id &&
                    currentPlan._id &&
                    plan._id == currentPlan._id.$id
                  "
                  class="green--text"
                >
                  {{
                    $t("account.whitelabel.resource.resourceDialog.currentPlan")
                  }}
                  <v-icon dense small color="green" class="ml-2 green-text">
                    mdi-check-outline</v-icon
                  >
                </h5>
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card elevation="0" v-if="selectedPlan" class="subscription-card">
              <div class="d-flex align-baseline justify-space-between">
                <div class="d-flex flex-column font-weight-bold">
                  <!-- <v-card-title class="headline font-weight-bold">{{
                    selectedPlan.name
                  }}</v-card-title> -->
                  <v-btn-toggle
                    class="mx-0"
                    color="primary"
                    dense
                    v-model="period"
                  >
                    <v-btn height="40">{{ `1 ${$t("common.year")}` }}</v-btn>
                    <v-btn height="40">{{ `2 ${$t("common.years")}` }}</v-btn>
                    <v-btn height="40">{{ `3 ${$t("common.years")}` }}</v-btn>
                  </v-btn-toggle>

                  <!-- <v-card-subtitle>{{
                      $n(
                        selectedPlan.resources.estimatedAverageMonthlyRevenue,
                        "currency"
                      )
                    }}</v-card-subtitle> -->
                  <div class="d-flex flex-column"></div>
                  <v-card-subtitle class="mb-4 pa-0 pt-3">
                    <span class="d-block title font-weight-semi-bold">{{
                      $n(yearPriceDialog, "currency")
                    }}</span
                    >{{
                      $t("account.whitelabel.resource.resourceDialog.perYear")
                    }}
                  </v-card-subtitle>
                </div>
                <!-- botoes de sign -->
                <div class="d-flex flex-column">
                  <div>
                    <v-btn
                      v-if="
                        currentPlan &&
                        currentPlan._id &&
                        selectedPlan._id == currentPlan._id.$id
                      "
                      elevation="0"
                      :loading="loading"
                      @click="signaturePlan()"
                      disabled
                      target="_blank"
                      color="success"
                    >
                      {{
                        $t(
                          "account.whitelabel.resource.resourceDialog.activePlan"
                        )
                      }}
                    </v-btn>
                    <v-btn
                      v-else
                      @click="signaturePlan()"
                      target="_blank"
                      color="success"
                    >
                      {{
                        $t(
                          "account.whitelabel.resource.resourceDialog.activatePlan"
                        )
                      }}
                    </v-btn>
                  </div>
                </div>
              </div>
              <v-card-subtitle class="mb-4" style="padding: 0px">
                <div class="d-flex flex-column">
                  <span
                    v-for="advantage in selectedPlan.advantagesText"
                    :key="advantage"
                    class=""
                  >
                    <v-icon class="mr-2">mdi-check</v-icon>{{ advantage }}</span
                  >
                </div>
              </v-card-subtitle>
              <v-divider class="my-3"></v-divider>
              <div class="d-flex align-baseline justify-space-between mb-4">
                <div class="d-flex flex-column font-weight-bold">
                  <div class="d-flex flex-column"></div>
                  <v-card-subtitle class="subtitle pa-0">
                    <span class="d-block title font-weight-semi-bold">{{
                      ` ${selectedPlan?.commission} % `
                    }}</span
                    >{{
                      $t(
                        "account.whitelabel.resource.resourceDialog.transactCommision"
                      )
                    }}
                  </v-card-subtitle>
                </div>
              </div>
              <v-card-subtitle class="mb-8" style="padding: 0px">
                <div class="d-flex flex-column">
                  <span
                    v-for="resource in selectedPlan.resourcesText"
                    :key="resource"
                    class=""
                  >
                    <v-icon class="mr-2">mdi-check</v-icon>{{ resource }}</span
                  >
                </div>
              </v-card-subtitle>
              <v-card color="#eeeeee" elevation="0" class="">
            <v-card-text>
              <span class="font-weight-bold"> {{
                    $t(
                      "account.whitelabel.resource.resourceDialog.bonus.title"
                    )
                  }}</span>
              <div class="d-flex align-end mb-2">
                <v-icon class="mr-2">mdi-check</v-icon>
                <span>
                  <strong class="green--text">{{
                    `${selectedPlan.resources?.discountStore} % ${this.$t(
                      "account.whitelabel.resource.resourceDialog.discount"
                    )} `
                  }}</strong>
                  {{
                    $t(
                      "account.whitelabel.resource.resourceDialog.bonus.tmtStore"
                    )
                  }}
                </span>
                <v-img
                  max-width="25"
                  class="ml-2"
                  width="25"
                  src="https://store.themediatrade.com/img/tmstorelogo.2b74392e.svg"
                ></v-img>
              </div>
              <div class="d-flex align-end mb-4">
                <v-icon class="mr-2">mdi-check</v-icon>
                <span>
              {{ $t(
                      "account.whitelabel.resource.resourceDialog.bonus.includedProducts"
                    ) }}
                </span>
                <v-img
                  class="ml-2 "
                  max-width="110"
                  src="https://tmt-s3-v2.s3.amazonaws.com/public/tunad_logo.svg"
                ></v-img>
              </div>
              <div class="d-flex align-center ">
                <v-icon class="mr-2">mdi-check</v-icon>
            <span>
              {{$t(
                      "account.whitelabel.resource.resourceDialog.bonus.includedProducts"
                    )}}
                </span>
                <v-img
                  class="ml-2"
                  max-width="150"
                  src="https://tmt-s3-v2.s3.amazonaws.com/public/kantaribopemedia_logo.svg"
                ></v-img>
              </div>
            </v-card-text>
          </v-card>
              <v-card-text> </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <template>
  <v-footer style="background-color:#eeeeee!important;" class="mt-3">
    <v-row justify="center" align="center" class="text-center">
      <v-col>
        <h3 class="subtitle-2">  {{$t(
 "account.whitelabel.resource.contact.sales.title" )}}</h3>
        <p class=" caption mb-0">{{contacts.sales.name}}</p>
          <div class="d-flex flex-column justify-center align-center">
            <p style="margin:0px" class=" caption"  v-html="
                $t('account.whitelabel.resource.contact.sales.email',{email:contacts.sales.email})
              "></p>
              <v-btn elevation="0" color="#eeeeee" class="my-0"    href="https://wa.me/+51950772668"
          target="_blank" ><span class="caption" v-html="
                $t('account.whitelabel.resource.contact.sales.phone',{phone:salesNumber})
              "></span></v-btn>
          </div>
      </v-col>
      <v-col>
        <h3 class="subtitle-2">Marketing</h3>
        <p class=" caption mb-0">{{contacts.mkt.name}}</p>
        <div class="d-flex flex-column justify-center align-center">
            <p style="margin:0px" class=" caption"  v-html="
                $t('account.whitelabel.resource.contact.marketing.email',{email:contacts.mkt.email})
              "></p>
              <v-btn elevation="0" color="#eeeeee" class="my-0"    href="https://wa.me/+5511982509060"
          target="_blank" ><span class="caption" v-html="
                $t('account.whitelabel.resource.contact.marketing.phone',{phone:contacts.mkt.phone})
              "></span></v-btn>
          </div>
      </v-col>
      <v-col>
        <h3 class="subtitle-2">  {{$t(
 "account.whitelabel.resource.contact.it.title" )}}</h3>
        <p class=" caption mb-0">{{contacts.it.name}}</p>
        <div class="d-flex flex-column justify-center align-center">
            <p style="margin:0px" class=" caption"  v-html="
                $t('account.whitelabel.resource.contact.it.email',{email:contacts.it.email})
              "></p>
              <v-btn elevation="0" color="#eeeeee" class="my-0" href="https://wa.me/+5511994164482"
              target="_blank"><span class="caption" v-html="
                $t('account.whitelabel.resource.contact.it.phone',{phone:contacts.it.phone})
              "></span></v-btn>
          </div>
      </v-col>
      <v-col>
        <h3 class="subtitle-2">Atención y soporte OpenPay</h3>
        <p class=" caption mb-0">Andrea Medina</p>
        <div class="d-flex flex-column justify-center align-center">
            <p style="margin:0px" class=" caption">
              Email: <strong>andrea.medina@openpay.pe</strong></p>
              <p class="ma-0 caption">Soporte: <strong>soporte@openpay.pe</strong></p>
              <v-btn elevation="0" color="#eeeeee" class="my-0"    href="https://wa.me/+51971022272"
          target="_blank" ><span class="caption" v-html="
                $t('account.whitelabel.resource.contact.it.phone',{phone: '+51 971 022 272'})
              "></span></v-btn>
          </div>
      </v-col>
    </v-row>
  </v-footer>
</template>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  data: () => ({
    contacts:{
      it:{
        name:'',
        phone:'+55 (11) 99416-4482',
        email:'ti@themediatrade.com'
      },
      mkt:{
        name:'',
        phone:' +55 (11) 98250-9060',
        email:'mkt@themediatrade.com'
      },
      sales:{
        name:'André Maggi',
        phone: '+55 (11) 98250-9060',
        email:'maggi@themediatrade.com'
      }
    },
    phone:'(11)9960-44236',
    period: 0,
    plans: [],
    selectedPlan: null,
    dialog: false,
    search: "",
    store: "",
    documents: [],
    headers: [],
    actualPlan: {},
    showPlans: false,
    loading: false,
    get stores() {
      return JSON.parse(localStorage.getItem("stores")) || null;
    },
  }),

  props: {
    doc: [Boolean, Object],
    loadingPlans: Boolean,
    allPlans: {
      type: Array,
      required: true,
    },

    currentPlan: {
      type: Object,
    },
    currentCicle: {
      type: Object,
      required: true,
    },
    orders: {
      type: Array,
      required: true,
    },
    statsInfo: {
      type: Object,
      required: true,
    },
  },

  computed: {
    salesNumber(){
        return '+51 950 772 668'
      if(this.doc && ['Per', 'Peru', 'PER'].includes(this.doc.origin)){
      }
      else{
        return '+55 (11) 98250-9060'
      }
    },
    yearPrice() {
      return (this.currentPlan.price / this.currentPlan.monthPeriod) * 12;
    },
    yearPriceDialog() {
      return (this.selectedPlan.price / this.selectedPlan.monthPeriod) * 12;
    },

    newVisitors() {
      const newUsers = [];
      for (let n in this.statsInfo.newUsers) {
        newUsers.push(this.statsInfo.newUsers[n]);
      }
      const nusers = newUsers.reduce((acc, curr) => acc + curr, 0);
      console.log("newUsers", nusers);
      return newUsers.reduce((acc, curr) => acc + curr, 0);
    },

    activeOrders() {
      const planFromDate = moment(this.currentCicle.from, "YYYY-MM-DD");
      const planToDate = moment(this.currentCicle.to, "YYYY-MM-DD");
      const result = this.orders.filter((orders) => {
        if (["paid", "waiting_upload"].includes(orders.status)) {
          const orderData = moment(orders.createdOn);
          //console.log("result",orders)
          //console.log("planFromDate",planFromDate)
          //console.log("planToDate",planToDate)
          console.log("orderData", orderData);
          if (orderData.isBetween(planFromDate, planToDate)) {
            //console.log("ordersBetween", orders);
            return orders;
          } else {
            console.log("fora do range de data", orders);
          }
        }
      });

      return result;
    },

    getGrossTransact() {
      let totalGross = 0;
      this.activeOrders.forEach((item) => {
        //console.log('gross',item.total.finalPrice )

        totalGross += isNaN(item.total.finalPrice) ? 0 : item.total.finalPrice;
      });
      return totalGross;
    },

    totalTransactions() {
      return this.activeOrders.length;
    },
  },

  mounted() {
    this.loadCurrentPlan();

    //this.store = this.stores.master.id;
    this.headers = [
      // { text: 'ID', value: 'uid' },
      {
        text: this.$t("sales.clientsList.name"),
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: this.$t("sales.clientsList.email"),
        align: "start",
        sortable: true,
        value: "email",
      },

      {
        text: this.$t("sales.clientsList.tel"),
        align: "start",
        sortable: true,
        value: "phoneNumber",
      },

      {
        text: this.$t("sales.clientsList.checked"),
        align: "start",
        sortable: true,
        value: "status",
      },
    ];
    this.documents = [
      {
        id: "001",
        name: " Ismael Ganoza Rubianes",
        email: "iganoza@americatv.pe",
        phoneNumber: "+51 994 056 115",
        cargo: "Editor",
        lastAccess: "2022-02-19 18:33:10",
        status: true,
      },
    ];
  },
  watch: {
    allPlans: {
      deep: true,
      handler() {
        this.loadCurrentPlan();
      },
    },
    period(val) {
      this.$emit("change-period", (val + 1) * 12);
    },
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),

    loadCurrentPlan() {
      const jsCurrent = this.currentPlan
        ? JSON.parse(JSON.stringify(this.currentPlan))
        : {};
      //console.log('jsCurrent', jsCurrent)
      if (
        !jsCurrent.hasOwnProperty("name") ||
        jsCurrent.monthPeriods / 12 - 1 != this.period
      ) {
        this.selectedPlan = this.allPlans[0];
        // console.log('selectedPlan', this.allPlans[0])
      } else {
        //console.log('nao entrei na condicao',this.jsCurrent)

        this.selectedPlan = jsCurrent;
      }
    },
    signaturePlan() {
      this.loading = true;
      const planId = { planId: this.selectedPlan._id };
      console.log("planId", planId);
      const url = `whitelabel/signature`;
      this.$axios
        .post(url, planId)
        .then((response) => {
          console.log("Signature", response);
          this.$emit("plan-signed", true);
          console.log("signed emmited");
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        })
        .then(() => {
          this.showSnack({
            text: this.$t(
              "account.whitelabel.resource.snackMessages.savedPlan"
            ),
            color: "success",
            timeout: 2800,
            icon: "mdi-check",
          });
        });
    },

    selectPlan(plan) {
      this.selectedPlan = plan;
    },
  },
};
</script>

<style scoped>
subscription-card {
  width: 500px;
  padding: 24px;
}

.v-divider {
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>
